import { Image } from 'Domain/Models';

export const sortImages = (images: Image[]): Image[] => {
  return images.sort((a, b) => a.sorting - b.sorting);
};
